import { render, staticRenderFns } from "./SettingsNotificationSms.vue?vue&type=template&id=05800962&"
import script from "./SettingsNotificationSms.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports